import type {
  CreateChatSnippetDTO,
  ShopSettingsDTO,
  UpdateChatSnippetDTO,
  UpdateShopSettingsDTO,
} from "@/modules/chat-tools/domain/contracts";
import { config } from "@/shared/lib/config";
import { fetcher } from "@/shared/lib/fetcher";

export type ChatSnippet = {
  id: string;
  title: string;
  body: string;
  sortOrder: number;
  createdAt: string;
  updatedAt: string;
};

export const chatToolsApi = {
  async listSnippets(): Promise<{ data: ChatSnippet[] }> {
    return fetcher.get(`${config.apiUrl}/chat-tools/snippets`);
  },
  async createSnippet(input: CreateChatSnippetDTO): Promise<ChatSnippet> {
    return fetcher.post(`${config.apiUrl}/chat-tools/snippets`, input);
  },
  async updateSnippet(
    id: string,
    input: UpdateChatSnippetDTO,
  ): Promise<ChatSnippet> {
    return fetcher.patch(`${config.apiUrl}/chat-tools/snippets/${id}`, input);
  },
  async deleteSnippet(id: string): Promise<{ ok: boolean }> {
    return fetcher.delete(`${config.apiUrl}/chat-tools/snippets/${id}`);
  },
  async getShopSettings(): Promise<ShopSettingsDTO> {
    return fetcher.get(`${config.apiUrl}/shop-settings`);
  },
  async updateShopSettings(input: UpdateShopSettingsDTO): Promise<ShopSettingsDTO> {
    return fetcher.patch(`${config.apiUrl}/shop-settings`, input);
  },
  async getOrderChatSummary(orderId: string): Promise<{ text: string }> {
    return fetcher.get(`${config.apiUrl}/orders/${orderId}/chat-summary`);
  },
};
